import { render, staticRenderFns } from "./FechaNacimiento.vue?vue&type=template&id=6572328b&"
import script from "./FechaNacimiento.vue?vue&type=script&lang=js&"
export * from "./FechaNacimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports